var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","stroke":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.2461 4.83863L12.4211 4.01367L7.00028 9.43453L1.57943 4.01367L0.754467 4.83863L7.00028 11.0844L13.2461 4.83863Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }